(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ee-monthly-top-seller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ee-top-seller')) {
    customElements.define('ee-top-seller', class extends HTMLElement {
      connectedCallback() {
        this.inView = false;
        this.handleVisibility = () => this.scheduleReflection();
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.scheduleReflection();
        });
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.observer.observe(this);
      }

      scheduleReflection() {
        clearTimeout(this.reflectionTimer);
        this.classList.remove('ee-reflection-active');
        if (!this.inView || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.reflectionTimer = setTimeout(() => {
          if (this.inView && !document.hidden) this.classList.add('ee-reflection-active');
        }, 500);
      }

      disconnectedCallback() {
        clearTimeout(this.reflectionTimer);
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.handleVisibility);
        this.classList.remove('ee-reflection-active');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ee-sale-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ee-sale-code')) {
    customElements.define('ee-sale-code', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.handleCopy = () => this.copyCode();
        this.button.addEventListener('click', this.handleCopy);
      }
      disconnectedCallback() {
        this.button.removeEventListener('click', this.handleCopy);
        clearTimeout(this.resetTimeout);
      }
      async copyCode() {
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          if (!this.isConnected) return;
          this.dataset.copied = 'true';
          this.button.setAttribute('aria-label', this.dataset.copiedLabel);
          this.button.title = this.dataset.copiedLabel;
          this.status.textContent = this.dataset.copiedLabel;
          clearTimeout(this.resetTimeout);
          this.resetTimeout = setTimeout(() => {
            delete this.dataset.copied;
            this.button.setAttribute('aria-label', this.dataset.copyLabel);
            this.button.title = this.dataset.copyLabel;
            this.status.textContent = '';
          }, 2000);
        } catch {
          if (this.isConnected) this.status.textContent = this.dataset.errorLabel;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ee-sale-ends-in"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ee-sale-countdown')) {
    customElements.define('ee-sale-countdown', class extends HTMLElement {
      connectedCallback() {
        this.endTime = Date.parse(this.dataset.end);
        if (!Number.isFinite(this.endTime)) {
          this.hidden = true;
          return;
        }
        this.units = Object.fromEntries(
          Array.from(this.querySelectorAll('[data-unit]'), element => [element.dataset.unit, element])
        );
        this.label = this.querySelector('.ee-sale-countdown__label').textContent;
        this.updateCountdown();
        if (!this.hidden) this.interval = setInterval(() => this.updateCountdown(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.interval);
      }
      updateCountdown() {
        const remaining = Math.max(0, Math.floor((this.endTime - Date.now()) / 1000));
        if (!remaining) {
          this.hidden = true;
          clearInterval(this.interval);
          return;
        }
        const values = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor(remaining / 3600) % 24,
          minutes: Math.floor(remaining / 60) % 60,
          seconds: remaining % 60
        };
        for (const [unit, value] of Object.entries(values)) {
          this.units[unit].textContent = String(value).padStart(2, '0');
        }
        this.setAttribute('aria-label', this.label + ' ' + Object.entries(values).map(([unit, value]) => value + ' ' + unit).join(', '));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
